module.exports = __webpack_public_path__ + "img/8.1f619d68.jpg";